// ─── TTS Service — supporto multilingua ───────────────────────────────────────
// Preprocessing italiano: accenti, abbreviazioni, orari.
// Altre lingue: solo pulizia markdown e tag ACTION.

const ABBREVIAZIONI = [
  [/\bSig\.\s/gi, 'Signor '],
  [/\bDr\.\s/gi,  'Dottor '],
  [/\bAtt\.\s/gi, 'Attenzione '],
  [/\bvs\.\s/gi,  'versus '],
  [/\becc\.\s/gi, 'eccetera '],
  [/\bn°/gi,      'numero '],
  [/\b€/gi,       'euro '],
  [/\b%/gi,       ' percento'],
  [/\b&\b/gi,     ' e '],
  [/\+/g,         ' più '],
  [/\bh\b/gi,     'ore '],
];

const ACCENTI = [
  [/\bperché\b/gi,    'per-ché'],
  [/\bperchè\b/gi,    'per-ché'],
  [/\bperchê\b/gi,    'per-ché'],
  [/\bfinché\b/gi,    'fin-ché'],
  [/\baffinché\b/gi,  'affin-ché'],
  [/\bpoiché\b/gi,    'poi-ché'],
  [/\bsicché\b/gi,    'sic-ché'],
  [/\bcioè\b/gi,      'cio-è'],
  [/\bcaffè\b/gi,     'caf-fè'],
  [/\bvirù\b/gi,      'vi-rù'],
  [/\bcittà\b/gi,     'cit-tà'],
  [/\buniversità\b/gi, 'uni-ver-si-tà'],
  [/\battività\b/gi,  'at-ti-vi-tà'],
  [/\bqualità\b/gi,   'qua-li-tà'],
  [/\bpossibilità\b/gi, 'pos-si-bi-li-tà'],
  [/\bpriorità\b/gi,  'prio-ri-tà'],
  [/\bfacultà\b/gi,   'fa-col-tà'],
  [/\blibertà\b/gi,   'li-ber-tà'],
  [/\bverità\b/gi,    've-ri-tà'],
  [/\bnecessità\b/gi, 'ne-ces-si-tà'],
];

function expandNumbers(text) {
  return text.replace(/\b(\d{1,2}):(\d{2})\b/g, (_, h, m) => {
    return m === '00' ? `${h} in punto` : `${h} e ${m}`;
  });
}

function stripMarkdown(text) {
  let t = text;
  t = t.replace(/\*\*(.*?)\*\*/g, '$1');
  t = t.replace(/\*(.*?)\*/g,     '$1');
  t = t.replace(/`(.*?)`/g,       '$1');
  t = t.replace(/#{1,6}\s/g,      '');
  t = t.replace(/\[ACTION:[^\]]+\]/g, '');
  return t;
}

export function preprocessTTS(text, lang = 'it') {
  let t = stripMarkdown(text);

  if (lang === 'it') {
    ABBREVIAZIONI.forEach(([re, sub]) => { t = t.replace(re, sub); });
    ACCENTI.forEach(([re, sub]) => { t = t.replace(re, sub); });
    t = expandNumbers(t);
    t = t.replace(/([;:])\s/g, '$1 ');
  }

  return t.trim();
}

const LANG_MAP = {
  it: 'it-IT', en: 'en-US', es: 'es-ES',
  fr: 'fr-FR', de: 'de-DE', pt: 'pt-PT', nl: 'nl-NL',
};

export function getBestVoice(langCode) {
  if (!window.speechSynthesis) return null;
  const voices = window.speechSynthesis.getVoices();
  const prefix = langCode.split('-')[0];
  return (
    voices.find(v => v.lang === langCode && v.localService) ||
    voices.find(v => v.lang === langCode) ||
    voices.find(v => v.lang.startsWith(prefix) && v.localService) ||
    voices.find(v => v.lang.startsWith(prefix)) ||
    null
  );
}

// Compatibilità con eventuali chiamate dirette pregresse
export function getBestItalianVoice() { return getBestVoice('it-IT'); }

export function speak(text, { rate = 1.05, pitch = 1, lang = 'it', onEnd, onError } = {}) {
  if (!window.speechSynthesis) return;
  window.speechSynthesis.cancel();

  const langCode  = LANG_MAP[lang] || 'it-IT';
  const processed = preprocessTTS(text, lang);
  const utt       = new SpeechSynthesisUtterance(processed);
  utt.lang  = langCode;
  utt.rate  = rate;
  utt.pitch = pitch;

  const assignAndSpeak = () => {
    const voice = getBestVoice(langCode);
    if (voice) utt.voice = voice;
    if (onEnd)   utt.onend   = onEnd;
    if (onError) utt.onerror = onError;
    window.speechSynthesis.speak(utt);
  };

  if (window.speechSynthesis.getVoices().length === 0) {
    window.speechSynthesis.onvoiceschanged = assignAndSpeak;
  } else {
    assignAndSpeak();
  }

  return utt;
}
